import Header from "@components/common/Header/Header";
import React from "react";
import styles from "./DefaultLayout.module.scss";
import requireAuthentication  from "@components/AuthenticatedComponent";
interface IProps {
    children: React.ReactNode;
  }

const AppLayout = (props: IProps) => {
    const { children } = props;
  
    return (
        <div>
            <Header />
            <div className={styles.Children}>{children}</div>
        </div>
    );
}

// export default AppLayout;
export default requireAuthentication(AppLayout)
